import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { ZStackElement, ZStackProps } from "../types";

function ZStackRoot<E extends React.ElementType = ZStackElement>({
  as,
  asChild = false,
  id,
  className,
  ...props
}: ZStackProps<E>) {
  const Component = resolveElement(asChild, as, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[ZStack] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      id={`ZStack${id ? `-${id}` : ""}`}
      className={cn("relative w-full h-full", className, classes)}
      {...native}
    />
  );
}

export default ZStackRoot;
